import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {

  static values = {
    type: String,
    labels: Array,
    series: Array,
    options: Object,
    slim: Boolean,
    stacked: Boolean,
    height: { type: Number, default: 300 }
  }

  connect() {
    const options = {
      chart: {
        type: this.typeValue || "bar",
        height: this.heightValue,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
      },
      series: this.seriesValue || [],
      labels: this.labelsValue || [],
      dataLabels: { enabled: false },
      ...this.optionsValue,
      yaxis: {
        labels: {
          formatter: function(val) {
            return val.toFixed(0);
          }
        }
      }
    }

    if (this.slimValue) {
        options.chart.sparkline = { enabled: true }

        options.chart.height = 40;

        const xaxis = {
          labels: {
            show: false
          },
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          }
        }

        options.xaxis = {
          ...options.xaxis,
          ...xaxis
        };

        const yaxis = {
          labels: {
            show: false
          },
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          }
        }

        options.yaxis = {
          ...options.yaxis,
          ...yaxis
        };

        const grid = {
          show: false,
          padding: { left: 0, right: 0, top: 0, bottom: 0 }
        }

        options.grid = {
          ...options.grid,
          ...grid
        };

        const dataLabels = { enabled: false }

        options.dataLabels = {
          ...dataLabels,
          ...options.dataLabels
        };
    }

    if (this.stackedValue) {
      options.chart.stackType = "100%";
      options.chart.stacked = true;

      const grid = {
        show: false,
        padding: { left: 20, right: 20, top: 0, bottom: 10 }
      }

      options.grid = {
        ...options.grid,
        ...grid
      };
    }

    const chart = new ApexCharts(this.element, options)
    chart.render()
  }
}
